import { render, staticRenderFns } from "./one_product_list.vue?vue&type=template&id=3af3aaae&"
import script from "./one_product_list.vue?vue&type=script&lang=js&"
export * from "./one_product_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports